import React from "react";
import { Button } from "reactstrap";
import { useAuth0 } from "@auth0/auth0-react";
import logo from "../assets/logo.svg";

const Hero = () => {
  const {
    user,
    isAuthenticated,
    loginWithRedirect,
    logout,
  } = useAuth0();

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      }
    });

  return (
    <div className="text-center hero my-5">
      <div style={{ width: "300px", marginLeft: "6em" }}>
        <img
        className=" unityLogo"
        src="https://cdn.auth0.com/quantum-assets/dist/1.0.4/logos/auth0/auth0-lockup-en-onlight.svg"
        
        alt="Unity Logo"
      />
      </div> 
      
      <a href="https://auth0.com" aria-label="link to Auth0 by Okta" className="sc-17e9fa4e-4 hnWCCq">
        <svg width="188" height="40" fill="none" xmlns="http://www.w3.org/2000/svg" className="sc-17e9fa4e-41 kXskzI">
          {/* SVG path data */}
        </svg>
      </a>
      {/* <Button
          id="qsLoginBtn"
          color="primary"
          className="btn-margin btn-pad"
          onClick={() => loginWithRedirect({ authorizationParams: { 'ext-app': 'app_mfa', 'mfa': true } })}
        >
          Enroll MFA
        </Button> */}
      <p className="lead" style={{ paddingTop: "2rem" }}>
        This is a sample application that demonstrates an authentication flow for
        an SPA.
      </p>
      <br></br>
      <Button style={{marginBottom: "2rem" }}
      id="qsLoginBtn"
      color="primary"
      className="btn-margin btn-pad"
        onClick={() => loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })}
    >
      Sign Up 
    </Button>
    <br></br>
      {!isAuthenticated ? (
        // <Button
        //   id="qsLoginBtn"
        //   color="primary"
        //   className="btn-margin btn-pad"
        //   onClick={() => loginWithRedirect({ authorizationParams: { connection: 'email' } })}
        // >
        //   Login with Secure Code (Email)
        // </Button>
        <Button
          id="qsLoginBtn"
          color="primary"
          className="btn-margin btn-pad"
          onClick={() => loginWithRedirect({ authorizationParams: { 'ext-app': 'mfa' } })}
        >
          Login with Secure Code (Email)
        </Button>
      ) : (
        <Button
          id="qsLogoutBtn"
          color="danger" // Set color to 'danger' for red
          className="btn-margin btn-pad"
          onClick={logoutWithRedirect}
        >
          Logout
        </Button>
      )}
    </div>
  );
};

export default Hero;
